import { Checkbox } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  GENDERS_OPTIONS,
  PF,
} from '@pages/Clients/NewClientsList/data/constants';
import type { GenderItem } from '@pages/Clients/NewClientsList/types';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui/FilterWrapper';

export const GenderFilter: ContentType = ({ open, onClose, id }) => {
  const { filtersMap, onChangeGenders } = useNewClientsListContext();

  const { genders } = filtersMap.get(id)!;

  const [localGenders, setLocalGenders] = useState<GenderItem['value'][]>([]);

  const onConfirm = useCallback(() => {
    onChangeGenders(localGenders, id);
    onClose?.();
  }, [localGenders, onChangeGenders, onClose, id]);

  const onChange = useCallback((checkedValues: GenderItem['value'][]) => {
    setLocalGenders(checkedValues);
  }, []);

  useEffect(() => {
    setLocalGenders(open ? genders : []);
  }, [open, genders]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Checkbox.Group<GenderItem['value']>
        className={`${PF}__checkbox-group`}
        options={GENDERS_OPTIONS}
        onChange={onChange}
        value={localGenders}
      />
    </FilterWrapper>
  );
};
